import { useState } from "react";

import { Stack, Typography } from "@mui/material";
import Alert from "@mui/material/Alert";
import { Box } from "@mui/system";

import { CopyToClipboardButton } from "components/CopyToClipboardButton";
import { NewTabLink } from "components/NewTabLink";
import { ISOStringToLocalReadableTimestamp } from "utils";

const AUTHOR_LABEL_BY_ROLE_TYPE: Record<
  ShipmentTrackingLink["created_by_role_type"],
  string
> = {
  CARRIER: "Added by the carrier",
  SHIPPER: "Added by the shipper",
};

interface Props {
  actions?: JSX.Element | null;
  trackingLink: ShipmentTrackingLink;
  showWarningOnCopy?: boolean;
}

export function ShipmentTrackingLinkDisplay(props: Props) {
  const { actions = null, trackingLink, showWarningOnCopy = false } = props;
  const [showCopyWarning, setShowCopyWarning] = useState<boolean>(false);
  return (
    <Stack direction="column" spacing={1} mb="2rem">
      <Stack direction="row" justifyItems="left" alignItems="flex-end">
        <Typography variant="h6" sx={{ mt: "1rem" }}>
          <b>Tracking URL: </b>
          <NewTabLink href={trackingLink.url}>
            <Typography>{trackingLink.url}</Typography>
          </NewTabLink>
        </Typography>
        <CopyToClipboardButton
          stringToCopy={trackingLink.url}
          message="Tracking URL copied to clipboard"
          onClick={() => setShowCopyWarning(true)}
        />
      </Stack>
      <Typography variant="body1" color="text.secondary">
        {`Added ${ISOStringToLocalReadableTimestamp(trackingLink.created_at)}`}
      </Typography>
      <Typography variant="body1" color="text.secondary">
        {AUTHOR_LABEL_BY_ROLE_TYPE[trackingLink.created_by_role_type]}
      </Typography>
      {showCopyWarning && showWarningOnCopy && (
        <Alert severity="info">
          We recommend not clicking on any links that seem suspicious or
          unfamiliar.
        </Alert>
      )}
      <Box>{actions}</Box>
    </Stack>
  );
}
